<!-- estação mobile -->
<div class="ion-hide-md-up">
  <div class="iqar-mobile claro" [ngClass]="isEstacaoPrincipal ? 'escuro' : 'claro'">
    <h1 [ngClass]="'color-tipo-classificacao-' + estacao?.indiceQualidadeArAtual?.classificacaoIqAr?.id">
      {{(estacao?.indiceQualidadeArAtual?.medicao?.indiceQualidadeAr | iqar:estacao?.indiceQualidadeArAtual?.medicao) || " - "}}
    </h1>
    <p [ngClass]="isEstacaoPrincipal ? 'escuro' : 'claro'">
      IQAr
    </p>
    <div class="div-barra-mobile"
         [ngClass]="'bg-tipo-classificacao-' + estacao?.indiceQualidadeArAtual?.classificacaoIqAr?.id"></div>
  </div>

   Estacação comum
  <div *ngIf="!isEstacaoPrincipal">
    <p class="nome-estacao-mobile claro ion-hide-md-up" *ngIf="!isEstacaoPrincipal">
      <ion-icon class="claro ion-hide-md-up" name="vento"></ion-icon>
      {{estacao?.noEstacao}}
    </p>
    <p class="local-estacao-mobile ion-hide-md-up claro" *ngIf="!isEstacaoPrincipal && estacao && estacao.municipio">
      <ion-icon class="claro ion-hide-md-up" name="mapa-pin-outline"></ion-icon>
      {{estacao?.municipio?.noMunicipio}} - {{estacao?.municipio?.uf.sgUf}}
    </p>
  </div>

   Estacação principal
  <div *ngIf="isEstacaoPrincipal">

    <p class="local-estacao-mobile claro ion-hide-md-up" *ngIf="estacao && estacao.municipio">
      <ion-icon class="ion-hide-md-up" name="mapa-pin-outline"></ion-icon>
      {{estacao.municipio?.noMunicipio}} - {{estacao.municipio?.uf.sgUf}}
    </p>
    <p class="nome-estacao-mobile claro ion-hide-md-up">
      <ion-icon class="ion-hide-md-up" name="vento" [ngClass]="isEstacaoPrincipal ? 'escuro' : 'claro'"></ion-icon>
      {{estacao?.noEstacao}}
    </p>
  </div>

  <p *ngIf="isEstacaoPrincipal" class="star-outline mobile ion-hide-md-up">
    <ion-icon name="star-outline"></ion-icon>
    Estação principal
  </p>

  <p class="classificacao-mobile ion-hide-md-up" [ngClass]="isEstacaoPrincipal ? 'escuro' : 'claro'">
    Classificação da Qualidade do Ar:
  </p>
  <p class="status-classificacao-mobile ion-hide-md-up"
     [ngClass]="'color-tipo-classificacao-' + estacao?.indiceQualidadeArAtual?.classificacaoIqAr?.id">
    {{estacao?.indiceQualidadeArAtual?.classificacaoIqAr?.noClassificacao || " - "}}
  </p>
  <p class="atualizacao-mobile ion-hide-md-up" [ngClass]="isEstacaoPrincipal ? 'escuro' : 'claro'">
    Atualizado em {{estacao.dtUltimaAtualizacao | date: 'dd/MM/yyyy HH:mm'}}
  </p>
  <app-clima *ngIf="isEstacaoPrincipal" [estacao]="estacao" [isEscuro]="true"></app-clima>
</div>
<!-- tablet/pwa -->
<ion-grid class="ion-hide-md-down" *ngIf="estacao">
  <ion-row>
    <ion-col size="4">
      <p class="p-titulo-tablet" [ngClass]="isEstacaoPrincipal ? 'escuro' : 'claro'">
        Estação
      </p>
      <p class="p-tablet" [ngClass]="isEstacaoPrincipal ? 'escuro' : 'claro'">
        <ion-icon class="ion-hide-md-down" name="vento" [ngClass]="isEstacaoPrincipal ? 'escuro' : 'claro'"></ion-icon>
        {{estacao?.noEstacao}}
      </p>
      <p *ngIf="isEstacaoPrincipal" class="star-outline ion-hide-md-down">
        <ion-icon name="star-outline"></ion-icon>
        Estação principal
      </p>
    </ion-col>
    <ion-col size="3">
      <p class="p-titulo-tablet" [ngClass]="isEstacaoPrincipal ? 'escuro' : 'claro'">
        Localização
      </p>
      <p class="p-tablet" [ngClass]="isEstacaoPrincipal ? 'escuro' : 'claro'" *ngIf="estacao && estacao.municipio">
        <ion-icon class="claro ion-hide-md-down" name="mapa-pin-outline"></ion-icon>
        {{estacao.municipio?.noMunicipio}} - {{estacao.municipio?.uf.sgUf}}
      </p>
    </ion-col>
    <ion-col size="3">
      <p class="p-titulo-tablet" [ngClass]="isEstacaoPrincipal ? 'escuro' : 'claro'">
        Classificação da Qualidade do Ar
      </p>
      <p class="p-class-tablet" [ngClass]="isEstacaoPrincipal ? 'escuro' : 'claro'"
         [ngClass]="'color-tipo-classificacao-' + estacao?.indiceQualidadeArAtual?.classificacaoIqAr?.id">
        {{estacao?.indiceQualidadeArAtual?.classificacaoIqAr?.noClassificacao || " - "}}
      </p>
    </ion-col>
    <ion-col size="2" class="col-iqar">
      <div class="iqar-tablet" [ngClass]="isEstacaoPrincipal ? 'escuro' : 'claro'">
        <h1 [ngClass]="'color-tipo-classificacao-' + estacao?.indiceQualidadeArAtual?.classificacaoIqAr?.id">
          {{(estacao?.indiceQualidadeArAtual?.medicao?.indiceQualidadeAr | iqar:estacao?.indiceQualidadeArAtual?.medicao) || " - " }}
        </h1>
        <p>
          IQAr
        </p>
        <div class="div-barra-tablet"
             [ngClass]="'bg-tipo-classificacao-' + estacao?.indiceQualidadeArAtual?.classificacaoIqAr?.id"></div>
      </div>
      <p class="p-atualizado-tablet" [ngClass]="isEstacaoPrincipal ? 'escuro' : 'claro'">
        Atualizado em {{estacao.dtUltimaAtualizacao | date: 'dd/MM/yyyy HH:mm'}}
      </p>
    </ion-col>
  </ion-row>
</ion-grid>


